import {SET_YEAR_SELECTED} from 'constants/action-types.js';
import {SET_TAGS_SELECTED} from 'constants/action-types.js';
import {SET_STYLES_SELECTED} from 'constants/action-types.js';
import {SET_SHOWING_SOUND_LIST} from 'constants/action-types.js';
import {SET_SAMPLE_DRAGGING} from 'constants/action-types.js';
import {SET_SAMPLES_DRAGGING} from 'constants/action-types.js';
import {SET_COUNTRIES_SELECTED} from 'constants/action-types.js';
import {SET_VIDEOS_SELECTED} from 'constants/action-types.js';
import {SET_CHORD_SELECTED} from 'constants/action-types.js';
import {SET_HIERARCHY_ROOT} from 'constants/action-types.js';
import {SET_HIERARCHY_TREE} from 'constants/action-types.js';
import {SET_SHOW_YEAR_SLIDER} from 'constants/action-types.js';
import {SET_SHOW_VIDEOS} from 'constants/action-types.js';
import {SET_SHOW_COUNTRIES} from 'constants/action-types.js';
import {SET_SHOW_STYLES} from 'constants/action-types.js';
import {SET_SHOW_TAGS} from 'constants/action-types.js';
import {SET_SHOW_CHORD_FILTER} from 'constants/action-types.js';
import {SET_SEARCH_RESULTS_SAMPLES} from 'constants/action-types.js';
import {SET_SELECTED_CHORD_SAMPLE} from 'constants/action-types.js';
import {SET_WAVEFORM_SELECTION} from 'constants/action-types.js';
import {SET_WAVEFORM_SELECTION_END} from 'constants/action-types.js';
import {SET_SEARCH_SORT_BY} from 'constants/action-types.js';
import {SET_SIDEBAR_COLLAPSED} from 'constants/action-types.js';
import {SET_SHOW_DATE_SAMPLED} from 'constants/action-types.js';
import {SET_DATE_SAMPLED} from 'constants/action-types.js';
import {SET_2D_SELECTION} from 'constants/action-types.js';
import {SET_SHOW_SAMPLES_2D} from 'constants/action-types.js';
import {SET_SIMILAR_SOUNDS_TO_FIND} from 'constants/action-types.js';
import {SET_DISCOGS_SELECTED} from 'constants/action-types.js';
import {SET_SEARCH_RESULTS_START} from 'constants/action-types.js';
import {SET_SAMPLE_TO_EXPLORE} from 'constants/action-types.js';
import {SET_QUICK_ADD_SEARCH_TEXT} from 'constants/action-types.js';
import {SET_EXPANDED_PROJECT} from 'constants/action-types.js';
import {SET_SIDEBAR_SEARCH_INPUT} from 'constants/action-types.js';
import {SET_SAMPLE_TAG_DRAGGING} from 'constants/action-types.js';
import {SET_CURRENT_SOUND_IN_LIST} from 'constants/action-types.js';
import {SET_CURRENT_TAG_IN_LIST} from 'constants/action-types.js';
import {SET_SAMPLE_EXPLORER_SELECTED} from 'constants/action-types.js';
import {CLEAR_DRAG_DROP} from 'constants/action-types.js';
import {SET_MAXIMIZE_EXPLORER} from 'constants/action-types.js';
import {SET_SOURCE_EXPLORING} from 'constants/action-types.js';
import {SET_YEAR_EXPLORING} from 'constants/action-types.js';
import {MOST_RECENT} from 'constants/sort-by.js';

let initialState = {
    sourceExploring: undefined,
    yearExploring: undefined,
    maximizeExplorer: undefined,
    currentSoundInList: undefined,
    currentTagInList: undefined,
    searchInput: undefined,
    yearSelected: undefined,
    countriesSelected: {},
    sampleToExplore: undefined,
    stylesSelected: {},
    tagsSelected: {},
    videosSelected: {},
    discogsSelected: {},
    sampleDragging: undefined,
    chordSelected: undefined,
    hierarchyRoot: undefined,
    hierarchyTreeTags: undefined,
    showYearSlider: false,
    showCountries: false,
    showStyles: false,
    showVideos: false,
    showTags: false,
    showChordFilter: false,
    showDateSampled: false,
    searchResultsSamples: [],
    selectedChordSample: undefined,
    waveformSelection: undefined,
    sortBy: MOST_RECENT,
    sidebarCollapsed: false,
    dateSampled: undefined,
    startX: 0,
    startY: 0,
    endX: 0,
    endY: 0,
    similarSoundsToFind: undefined,
    showSamples2D: false,
    searchResultsStart: 0,
    quickAddSearchText: '',
    sampleTagDragging: undefined,
};

const selectorReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case CLEAR_DRAG_DROP:
        return {
            ... state,
            sampleDragging: undefined,
            sampleTagDragging: undefined,
            samplesDragging: undefined
        };
    case SET_MAXIMIZE_EXPLORER:
        return {
            ...state,
            explorerMaximized: action.payload
        };
    case SET_SOURCE_EXPLORING:
        return {
            ... state,
            sourceExploring: action.payload
        };
    case SET_YEAR_EXPLORING:
        return {
            ... state,
            yearExploring: action.payload
        };
    case SET_SAMPLE_EXPLORER_SELECTED:
        return {
            ... state,
            sampleExplorerSelected: action.payload
        };
    case SET_YEAR_SELECTED:
        return {
            ...state,
            yearSelected: action.payload
        };
    case SET_TAGS_SELECTED:
        return {
            ...state,
            tagsSelected: action.payload
        };
    case SET_SEARCH_RESULTS_START:
        return {
            ...state,
            searchResultsStart: action.payload
        };
    case SET_COUNTRIES_SELECTED:
        return {
            ...state,
            countriesSelected: action.payload
        };
    case SET_SIDEBAR_SEARCH_INPUT:
        return {
            ... state,
            searchInput: action.payload
        };
    case SET_VIDEOS_SELECTED:
        return {
            ...state,
            videosSelected: action.payload
        };
    case SET_DISCOGS_SELECTED:
        return {
            ...state,
            discogsSelected: action.payload
        };
    case SET_STYLES_SELECTED:
        return {
            ...state,
            stylesSelected: action.payload
        };
    case SET_SAMPLES_DRAGGING:
        return {
            ...state,
            samplesDragging: action.payload
        };
    case SET_HIERARCHY_ROOT:
        return {
            ...state,
            hierarchyRoot: action.payload
        };
    case SET_HIERARCHY_TREE:
        return {
            ...state,
            hierarchyTreeTags: action.payload
        };
    case SET_SHOW_TAGS:
        return {
            ...state,
            showTags: action.payload
        };
    case SET_SHOW_YEAR_SLIDER:
        return {
            ...state,
            showYearSlider: action.payload
        };
    case SET_SHOW_COUNTRIES:
        return {
            ...state,
            showCountries : action.payload
        };
    case SET_SHOW_STYLES:
        return {
            ...state,
            showStyles: action.payload
        };
    case SET_SHOW_CHORD_FILTER:
        return {
            ...state,
            showChordFilter: action.payload
        };
    case SET_CHORD_SELECTED:
        return {
            ...state,
            chordSelected: action.payload
        };
     case SET_SEARCH_RESULTS_SAMPLES:
        return {
            ...state,
            searchResultsSamples: action.payload
        };
     case SET_SELECTED_CHORD_SAMPLE:
        return {
            ...state,
            selectedChordSample: action.payload
        };
     case SET_SHOW_VIDEOS:
        return {
            ...state,
            showVideos: action.payload
        };
    case SET_WAVEFORM_SELECTION:
        return {
            ...state,
            waveformSelection: action.payload
        };
    case SET_WAVEFORM_SELECTION_END:
        let waveformSelection = {
            ... state.waveformSelection,
            end: action.payload
        };
        return {
            ...state,
            waveformSelection: waveformSelection
        };
    case SET_SEARCH_SORT_BY:
        return {
            ...state,
            sortBy: action.payload
        };
    case SET_SIDEBAR_COLLAPSED:
        return {
            ...state,
            sidebarCollapsed: action.payload
        };
    case SET_SHOW_DATE_SAMPLED:
        return {
            ...state,
            showDateSampled: action.payload
        };
    case SET_DATE_SAMPLED:
        return {
            ...state,
            dateSampled: action.payload
        };
    case SET_SIMILAR_SOUNDS_TO_FIND:
        return {
            ...state,
            similarSoundsToFind: action.payload
        };
    case SET_SHOW_SAMPLES_2D:
        return {
            ...state,
            showSamples2D: action.payload
        };
    case SET_2D_SELECTION:
        return {
            ...state,
            startX: action.payload.startX,
            startY: action.payload.startY,
            endX: action.payload.endX,
            endY: action.payload.endY,
        };
    case SET_SAMPLE_DRAGGING:
        return {
            ... state,
            sampleDragging: action.payload
        };
    case SET_SAMPLE_TO_EXPLORE:
        return {
            ... state,
            showSamples2D: action.payload !== undefined,
            sampleToExplore: action.payload,
        };
    case SET_QUICK_ADD_SEARCH_TEXT:
        return {
            ... state,
            quickAddSearchText: action.payload
        };
    case SET_EXPANDED_PROJECT:
        return {
            ... state,
            expandedProject: action.payload
        };
    case SET_SAMPLE_TAG_DRAGGING:
        return {
            ... state,
            sampleTagDragging: action.payload
        };
    case SET_CURRENT_SOUND_IN_LIST:
        return {
            ... state,
            currentSoundInList: action.payload
        };
    case SET_CURRENT_TAG_IN_LIST:
        return {
            ... state,
            currentTagInList: action.payload
        };
    case SET_SHOWING_SOUND_LIST:
        return {
            ... state,
            showingSoundList: action.payload
        };
   default:
        return state;
    }
}

export default selectorReducer;
